import ModalLayout from './ModalLayout';
export default ModalLayout;
